<div class="td-cnt-ext-extra-cost">
    <div class="td-cnt-extra-cost">
        <div class="td-cnt-title">
            <span class="te-title">{{'enquiryBook.extraCosts' | translate}}</span>
        </div>
        <div class="td-cnt-body-dto">
            <div class="d-flex">
                <teiasoft-input [allowNegative]="false" [type]="'number'" [isRequired]="true" [readOnly]="false"
                    [labelText]="'grid.extraCostAmount' | translate" [value]="amount"
                    (onInput)="onInputAmount($event)"></teiasoft-input>
                <teiasoft-select class="grid-item" [labelText]="'grid.extraCostUom' | translate" [isRequired]="true"
                    [disabled]="true" [optionsList]="uomOptionsList" [spaceLabel]="true" [noMinWidth]="false"
                    [isValid]="true" [defaultValue]="uom" [readOnly]="true"></teiasoft-select>
            </div>

            <div>
                <teiasoft-grid [title]="'edit-enquiry-item'" [gridDescription]="'enquiryBook.items' | translate"
                    [autoCompleteId]="'order-ec-items'" [columnsToShow]="columnsToShowItem" [dataSet]="items"
                    [customIcoCols]="customIcoCols" [calculatedCols]="calculatedCols" [showFooter]="false"
                    [selectable]="true" [multiSelection]="true" [disableAllSelection]='false' [autoWidth]="true"
                    [showEditIcon]="false" [dateFormat]="globals.dateFormat!" [dateTimeFormat]="globals.dateTimeFormat!"
                    [sortable]="false" [enquiryNo]="enquiryNo!" [gridName]="'items'"
                    (rowsSelected)="onRowSelection($event)" [selectedRows]="selectedItems"
                    [customRenderers]="customRenderers"></teiasoft-grid>
            </div>

        </div>
        <div class="td-cnt-btn">
            <teiasoft-button (click)="onCancelClick()" [type]="'tb-cancel'" [text]="'commons.cancel' | translate"
                class="mr-5"></teiasoft-button>
            <teiasoft-button (click)="onSaveClick()" [type]="'tb-primary'" [text]="'commons.save' | translate"
                [disabled]="selectedItemsNo.length < 1"></teiasoft-button>
        </div>
    </div>
</div>
<!-- ITEM CUSTOM CELLS -->
<ng-template #viewCost let-row let-column="column" let-uomColumn="uomColumn">
    <div class="extra-cost-row">
        <span style="margin-right: 0.2vw;">{{row[column] && row[column].toFixed(2)}}</span>
        <span> {{row[column] && row[column] >= 0 ? row[uomColumn || 'costsUom'] : ''}}</span>
    </div>
</ng-template>
<ng-template #viewExtraCosts let-row>
    <div class="extra-cost-row">
        <span style="margin-right: 0.2vw;">{{row.extraCosts!! && row.extraCosts.toFixed(2)}}</span>
        <span> {{row.extraCosts > 0 ? row.costsUom : ''}}</span>
    </div>
</ng-template>